module.exports = __webpack_public_path__ + "static/img/blog3.a2c5c59c.jpg";